import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Every route gets a canonical URL of its own. Without this the one baked into index.html pointed
 * search engines at the homepage from every page on the site, which reads as duplicate content.
 * Pages that need something different (an introducer's copy of a funding page, say) set their own
 * canonical through useSeo — those effects run after this one, so they win.
 */
export default function Canonical() {
  const { pathname } = useLocation();

  useEffect(() => {
    let el = document.querySelector('link[rel="canonical"]');
    if (!el) {
      el = document.createElement("link");
      el.setAttribute("rel", "canonical");
      document.head.appendChild(el);
    }
    const clean = pathname.length > 1 ? pathname.replace(/\/+$/, "") : "/";
    el.setAttribute("href", `${window.location.origin}${clean}`);
  }, [pathname]);

  return null;
}
